import MedicalEvaluation from './MedicalEvaluation'
export default MedicalEvaluation